import axios from 'axios'
const baseURL = process.env.REACT_APP_API_URL
const baseBatchURL = process.env.REACT_APP_BATCH_API_URL
// const baseBatchURL = 'http://localhost:5001'
// const baseURL = `https://apps.meerkats.ai`
const apiClient = axios.create({
    baseURL: `${baseURL}/api/v1`,
    headers: {
        'Content-type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('accessToken')
    }
})

apiClient.interceptors.request.use(function (config) {
    const token = localStorage.getItem('accessToken')
    if (token) {
        config.headers.Authorization = `Bearer ${token}`
    }
    return config
})
const batchClient = axios.create({
    baseURL: `${baseBatchURL}/api/v1`,
    headers: {
        'Content-type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('accessToken')
    }
})

batchClient.interceptors.request.use(function (config) {
    const token = localStorage.getItem('accessToken')
    if (token) {
        config.headers.Authorization = `Bearer ${token}`
    }
    return config
})
const v2Client = axios.create({
    baseURL: `${baseURL}/api/v2`,
    headers: {
        'Content-type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('accessToken')
    }
})

v2Client.interceptors.request.use(function (config) {
    const token = localStorage.getItem('accessToken')
    if (token) {
        config.headers.Authorization = `Bearer ${token}`
    }
    return config
})
export { batchClient, v2Client }
export default apiClient
